<template>
  <div id="app" class="wrapper">

    <VHead v-if="$route.meta.requireAuth"></VHead>

    <Sidebar v-if="$route.meta.requireAuth"></Sidebar>

    <router-view></router-view>
    
  </div>
</template>

<script>

import VHead from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";

export default {
  name: 'App',
  components: {
    VHead,
    Sidebar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 12px;
}
.form-control{font-size: 12px;}
.btn-group-sm>.btn, .btn-sm{font-size: .5rem;}
</style>



// WEBPACK FOOTER //
// src/App.vue